export const paymentFor = [
    { val: 'Goods', label : "Goods" },
    { val: 'Service', label : "Service" }
    
];

export const currencies = [
    { val: '0.5300', label : "USD" },
    { val: '1.9451', label : "AED" }
];